import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=6cf43d10&scoped=true"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=6cf43d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf43d10",
  null
  
)

export default component.exports